import { CORE_SEAT_LEVEL_TO_API_NAME, getProductForSkuId } from 'pricing-pages-lib/utils/productsUtils';
import { STARTER, currentOrderedPaidProductLevels } from 'self-service-api/constants/ProductLevels';
import { NO_PROMOTION, promotionKeys } from 'self-service-api/constants/Promotions';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { getCrmSuiteLowestTermsOfferId, getOfferInfo } from './offerUtils';
export const getAllEligiblePromotions = ({
  promotions
}) => {
  if (!promotions) return [];
  const allPromotions = Object.values(promotions.productsEligibleForDirectPromotions || {});
  const uniquePromotions = {};
  for (const promotion of allPromotions) {
    for (const versionSpecificPromotion of Object.values(promotion)) {
      const {
        eligiblePromotion
      } = versionSpecificPromotion;
      if (eligiblePromotion && eligiblePromotion !== NO_PROMOTION) {
        uniquePromotions[eligiblePromotion] = true;
      }
    }
  }
  return Object.keys(uniquePromotions);
};
export const getOffersMap = ({
  promotions: {
    offersById
  }
}) => offersById;
export const getIsHsfxEligible = ({
  promotions
}) => {
  const eligiblePromotions = getAllEligiblePromotions({
    promotions
  });
  return eligiblePromotions.includes(promotionKeys.HSFS_SEED_V2) || eligiblePromotions.includes(promotionKeys.HSFS_SERIES_A_V2) || eligiblePromotions.includes(promotionKeys.HSFX_ENTREPRENEUR_V2) || eligiblePromotions.includes(promotionKeys.HSFX_BOOTSTRAP);
};
const defaultPromotion = {
  dtbOfferIds: [],
  offerIds: [],
  quantityPackOfferIdsBySkuUuid: {}
};
export const getProductPromotion = ({
  promotions
}, {
  apiName,
  versionNumber
}) => {
  const {
    productsEligibleForDirectPromotions
  } = promotions;
  return productsEligibleForDirectPromotions && productsEligibleForDirectPromotions[apiName] && productsEligibleForDirectPromotions[apiName][versionNumber] || defaultPromotion;
};
export const getPromotionExistsForApiName = ({
  promotions
}, {
  apiName
}) => {
  const {
    productsEligibleForDirectPromotions
  } = promotions;
  return !!(productsEligibleForDirectPromotions && productsEligibleForDirectPromotions[apiName]);
};
export const getPromotionForSkuId = (state, {
  skuId
}) => {
  const {
    productData: {
      skuMap
    }
  } = state;
  const sku = skuMap[skuId];
  let versionNumber;
  if (sku.skuType === QUANTITY_PACK) versionNumber = skuMap[sku.productVersionSkuId].versionNumber;else versionNumber = sku.versionNumber;
  const {
    apiName
  } = getProductForSkuId(state, {
    skuId
  });
  return getProductPromotion(state, {
    apiName,
    versionNumber
  });
};

// Active as of 3/8/24 for non-Seats starter customers upgrading to Franken-Suite
const STARTER_SUITE_NON_SEATS_PROMO_DISCOUNT = 77.778;
export const getIsFrankenStarterEligible = state => {
  if (!Object.keys(state.promotions).length) return false;
  const offerId = getCrmSuiteLowestTermsOfferId(state, {
    productLevel: STARTER
  });
  const offerInfo = getOfferInfo(state, {
    offerId
  });
  const discount = offerInfo ? offerInfo.discount : 0;
  return discount === STARTER_SUITE_NON_SEATS_PROMO_DISCOUNT;
};
export const getPromotionsAreEmpty = state => {
  return !Object.keys(state.promotions).length;
};
export const hasAnyTBSkuInPromotions = state => {
  if (getPromotionsAreEmpty(state)) return null;
  if (!Object.keys(state.promotions.crmSuiteOfferIds).length) {
    return true;
  }
  return false;
};
export const hasAnySeatsSkuInPromotions = state => {
  if (getPromotionsAreEmpty(state)) return null;
  const coreSeatApiNames = currentOrderedPaidProductLevels.map(productLevel => CORE_SEAT_LEVEL_TO_API_NAME[productLevel]);
  return coreSeatApiNames.some(apiName => getPromotionExistsForApiName(state, {
    apiName
  }));
};
export const hasUnbundledCrmSuiteOfferIdsInPromotions = state => {
  if (getPromotionsAreEmpty(state)) return null;
  return !!Object.keys(state.promotions.crmSuiteOfferIds).length;
};